module.exports = __webpack_public_path__ + "static/media/12-rectangle-available.28585534.svg";